export default __webpack_public_path__ + "locales/tr/FillPDFDialog.json?hash=c7d9562f2b8af28ba1e5a79328da88ab";